import { LinksCompartidos } from './../models/linkscompartidos.interface';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BaseResponse } from "../../../shared/models/base-api-response.interface";
import { endpoint, httpOptions } from "../../../shared/apis/endpoint";
import { environment as env } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class LinkscompartidosService {
  constructor(private _http: HttpClient) {}

  LinkCompartidoAdd(link: LinksCompartidos): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.LINK_COMPARTIDO_ADD}`;
    return this._http
      .post(requestUrl, link, httpOptions)
      .pipe(map((resp: any) => resp as BaseResponse));
  }

  LinkCompartidoEncrypt(token: string): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.LINK_COMPARTIDO_DESENCRYPTAR}${token}`;
    return this._http
      .get(requestUrl)
      .pipe(map((resp: any) => resp as BaseResponse));
  }

  LinkCompartidoIsExpired(link: string): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.LINK_COMPARTIDO_ISEXPIRED}${link}`;
    return this._http
      .get(requestUrl)
      .pipe(map((resp: any) => resp as BaseResponse));
  }
}
